import _ from 'lodash';
import { isAlwaysAvailable, AvailabilityIterator } from 'availability';
import { unionIntervals } from 'interval-utils';
import moment from 'moment';
import { Availability, WeeklyTimeWindow } from '../types/Availability';

export function unionWeeklyAvailabilities(
  availabilities: Availability[],
): Availability {
  if (availabilities.some(alwaysAvailable)) {
    return { weekly: [{ minuteOfWeek: 0, durationMins: 10080 }] };
  }

  const intervals = availabilities
    .map(availabilityToWeekly)
    .map(weeklyAvailabilityToIntervals);

  const unionizedInterval = unionIntervals(...intervals);

  return {
    weekly: intervalsToAvailability(unionizedInterval),
  };
}

export function unionAvailabilityExceptions(availabilities: Availability[]) {
  return availabilities.flatMap((a) => a.exceptions || []).filter(Boolean);
}

function availabilityToWeekly(availability: Availability) {
  return availability && availability.weekly ? availability.weekly : [];
}

function weeklyAvailabilityToIntervals(weekly: WeeklyTimeWindow[]) {
  return _.map(weekly, availabilityRangeToInterval);
}

function availabilityRangeToInterval({
  minuteOfWeek,
  durationMins,
}: WeeklyTimeWindow) {
  return [minuteOfWeek, minuteOfWeek + durationMins];
}

function intervalsToAvailability(intervals: [number, number][]) {
  return _.map(intervals, ([from, to]) => ({
    minuteOfWeek: from,
    durationMins: to - from,
  }));
}

function alwaysAvailable(availability: Availability) {
  return (
    typeof availability.weekly === 'undefined' ||
    isAlwaysAvailable(new AvailabilityIterator({ availability, cal: moment() }))
  );
}
